import { render, staticRenderFns } from "./EasyDataView.vue?vue&type=template&id=f6467cda"
import script from "./EasyDataView.vue?vue&type=script&lang=jsx"
export * from "./EasyDataView.vue?vue&type=script&lang=jsx"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports